import { render, staticRenderFns } from "./DemoAlert.vue?vue&type=template&id=41578acc&scoped=true"
import script from "./DemoAlert.vue?vue&type=script&lang=js"
export * from "./DemoAlert.vue?vue&type=script&lang=js"
import style0 from "./DemoAlert.vue?vue&type=style&index=0&id=41578acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41578acc",
  null
  
)

export default component.exports